//Created by wangshuyi on 07/03/2018.

'use strict';
import dolphinCoreConfig from '../config';

class Dict {
    constructor(param) {
        this.opts = Object.assign({Vue: null}, dolphinCoreConfig.dict, param);
        this.dictCache = {};
        this.dictLoading = {};
    }

    addDict(code, data) {
        this.dictCache[code] = data;
        return Dict;
    }

    getDict(code, params) {
        return new Promise((resolve, reject) => {
            let data = this.dictCache[code];

            if (data) {
                resolve(data);
            } else if (this.opts.ajaxFlag) {
                this.loadDict(code).then(options => {
                    resolve(options);
                }).catch(e => {
                    resolve([]);
                });
            } else {
                resolve(null);
            }
        });
    }

    loadDict(code) {
        return new Promise((resolve, reject) => {
            if (!this.dictCache[code] && this.dictLoading[code]) {
                let getDictFormLoading = setInterval(() => {
                    if (this.dictCache[code]) {
                        resolve(this.dictCache[code]);
                        clearInterval(getDictFormLoading);
                    }
                }, 200);
            } else {
                this.dictLoading[code] = true;
                if(this.opts.serverType === 'NodeJs'){
                    this.opts.Vue.$ajax({
                        url: this.opts.server,
                        pathData: {code: code},
                    }).then(reData => {
                        if (reData.rows.length > 0) {
                            this.dictCache[code] = reData.rows;
                            resolve(reData.rows);
                        } else {
                            reject(reData.message);
                        }
                    }).catch(err => {
                        reject(err.message);
                    });
                }else if(this.opts.serverType === 'DotNet'){
                    this.opts.Vue.$erp({
                        url: this.opts.server,
                        data: {typeCode: code},
                    }).then(({data, message}) => {
                        if (data.length > 0) {
                            let options = data.map(d => ({text: d['DIC_NAME'], code: d['DIC_CODE']}));
                            this.dictCache[code] = options;
                            resolve(options);
                        } else {
                            reject(reData.message);
                        }
                    }).catch(err => {
                        reject(err.message);
                    });
                }
            }
        });
    }

    getDictText(code, option, params) {
        return this.getDict(code).then(options => {
            let text = option;
            options.forEach(o => {
                if (o.code == option) {
                    text = o[params['labelField'] || 'text'];
                }
            });
            return text;
        }).catch(e => {
            console.error(e);
            return option
        });
    }
}

let dict = new Dict();

let $dict = function (code, option, params = {}) {
    dict.opts.Vue = this;
    if (option) {
        return dict.getDictText(code, option, params);
    } else {
        return dict.getDict(code, params);
    }
};
$dict.addDict = function (name, data) {
    dict.addDict(name, data);
};
export default $dict
